import { render, staticRenderFns } from "./CreateProvince.vue?vue&type=template&id=f6979932&scoped=true"
import script from "./CreateProvince.vue?vue&type=script&lang=js"
export * from "./CreateProvince.vue?vue&type=script&lang=js"
import style0 from "./CreateProvince.vue?vue&type=style&index=0&id=f6979932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6979932",
  null
  
)

export default component.exports